import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const ArrowRightComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__arrowRight"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M2.5 6L9.5 6" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 2.5L9.5 6L6 9.5" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const ArrowRight = withIcon(ArrowRightComponent);
